@if (news) {
  <a
    class="ui-news-card"
    (click)="onRedirectToNews()"
    [externalLink]="news.url"
    [routerLink]="'/news-article/' + news.id"
    [title]="news.title"
  >
    <div class="ui-news-card__image-wrapper">
      <img
        class="ui-news-card__image"
        width="260"
        height="146"
        [ngSrc]="news.imageUrl || placeholderImage"
        [alt]="news?.title + 'news card'"
      />
    </div>
    <div class="ui-news-card__content">
      <h3 class="ui-news-card__title two-rows-ellipsis" [class.longText]="news.title.length > longtext">
        {{ news.title.slice(0, longtext) }}
      </h3>
      <p class="ui-news-card__date">{{ date }}</p>
    </div>
  </a>
}
